var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"update-prompt"},[_c('span',{staticClass:"update-prompt__text"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"update-prompt__action",on:{"click":_vm.reload}},[_vm._v(_vm._s(_vm.actionText))]),_c('i',{staticClass:"material-icons update-prompt__close",on:{"click":_vm.dismiss}},[_vm._v("close")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }